import { useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  TextField,
  DialogActions,
  DialogContent,
} from "@mui/material";
import ResponsiveDialog from "../UI/ResponsiveDialog";
import { useMutation } from "@apollo/client";
import {
  ADD_TEAM,
  GET_TEAMS,
  GET_TEAMS_BY_MANAGER_ID,
  TEAMS_WITH_PERMISSION,
} from "../../GraphQL/Teams";
import useNotification from "../../hooks/useNotification.js";

const NewTeamDialog = (props) => {
  const [team, setTeam] = useState({ name: "" });
  const { notifySuccess } = useNotification();

  const isValid = team.name.trim().length > 0;

  const [addTeam, { loading, error }] = useMutation(ADD_TEAM, {
    variables: {
      managerId: props.managerId,
      name: team.name,
    },
    refetchQueries: [GET_TEAMS, GET_TEAMS_BY_MANAGER_ID, TEAMS_WITH_PERMISSION],
    onCompleted: () => { notifySuccess("Team created."); props.setOpen(false); },
  });

  return (
    <div>
      <ResponsiveDialog
        open={props.open}
        onKeyDown={(e) => {
          if (e.key === "Enter" && isValid) {
            addTeam();
          } else if (e.key === "Escape") {
            props.setOpen(false);
          }
        }}
        title="Team"
        onClose={() => props.setOpen(false)}
      >
        <DialogContent>
          <TextField
            data-testid="name"
            autoFocus
            margin="dense"
            id="name"
            label="Name"
            type="text"
            fullWidth
            variant="standard"
            onChange={(e) => {
              setTeam({ ...team, name: e.target.value });
            }}
          />
        </DialogContent>
        {error && (
          <Alert severity="error" sx={{ mx: 2, mb: 1 }}>
            {error.message}
          </Alert>
        )}
        <DialogActions>
          <Button
            data-testid="saveNewTeamDialogButton"
            variant="contained"
            onClick={() => addTeam()}
            disabled={loading || !isValid}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "inherit" }} />
            ) : (
              "Create"
            )}
          </Button>
          <Button
            data-testid="closeNewTeamDialogButton"
            onClick={() => props.setOpen(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </ResponsiveDialog>
    </div>
  );
};

export default NewTeamDialog;
